export enum Curtain {
	Left,
	Right,
	Both
}

